import { BfxBlotterOrdersContextMenuItemCancelState } from "./BfxBlotterOrdersContextMenuItemCancelState";

import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterOrdersContextMenuItemTransferState } from "./BfxBlotterOrdersContextMenuItemTransferState";

export class BfxBlotterOrdersContextMenuTransferItem extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_TRANSFER,
      "Transfer",
      BfxBlotterOrdersContextMenuTransferItem.checkAvailableFn(),
      BfxBlotterOrdersContextMenuTransferItem.checkEnabledFn(),
      ContextMenuItemStateCommandCriteria.MenuItem,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new BfxBlotterOrdersContextMenuItemTransferState();
    this.state.title = oldState.title;
  }

  private static checkAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
    ) {
      itemState.available = menuState.canTransfer || menuState.canTransferUnrestricted;
    };
  }

  private static checkEnabledFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemTransferState,
      item: CubiqTS.OrderDataImpl,
    ) {
      if (!item) {
        itemState.enabled = false;
      } else if (!itemState.enabled || itemState.count == 0) {
        itemState.enabled = BfxBlotterOrdersContextMenuTransferItem.checkMembership(
          item,
          menuState,
          itemState,
        );
        itemState.enabled =
          itemState.enabled &&
          BfxBlotterOrdersContextMenuTransferItem.checkOrderState(item, menuState);
        itemState.enabled =
          itemState.enabled && BfxBlotterOrdersContextMenuTransferItem.checkLockType(item);
      }

      itemState.count++;
    };
  }

  private static checkMembership(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
    itemState: BfxBlotterOrdersContextMenuItemTransferState,
  ): boolean {
    let enabled: boolean = menuState.canTransferUnrestricted;

    if (item.deskId != null && menuState.traderGroups.has(item.deskId.toString())) {
      let traderGroup: CubiqTS.TradingGroupImpl = menuState.traderGroups.get(
        item.deskId.toString(),
      );
      let external: boolean = traderGroup != null && traderGroup.isExternallyFilledFg;
      if (external) {
        return false;
      }
    }

    if (!enabled) {
      // For trader check if order is in trader group, sales group for sales user or clients for client user
      if (
        menuState.activeUser.userTypeId == CubiqTS.UserType.TRADER &&
        item.deskId != null &&
        !menuState.canTransferUnrestricted
      ) {
        enabled = menuState.activeUser.tradingGroupsIdSet.has(item.deskId.toString());
      }
    }

    return enabled;
  }

  private static checkOrderState(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
  ): boolean {
    let enabled: boolean = false;

    switch (item.orderState) {
      case CubiqTS.OrderState.ACTIVE:
      case CubiqTS.OrderState.PENDING:
      case CubiqTS.OrderState.SUSPENDED:
      case CubiqTS.OrderState.TRIGGERED:
      case CubiqTS.OrderState.PENDING_CANCELLATION:
      case CubiqTS.OrderState.FILLING:
      case CubiqTS.OrderState.FILL_PENDING:
        enabled = true;
        break;
      default:
        enabled = false;
        break;
    }

    return (
      enabled &&
      item.targetDeskId == null &&
      (item.lockUserId == null ||
        item.lockUserId.toString() == menuState.activeUser.userId.toString())
    );
  }

  private static checkLockType(item: CubiqTS.OrderDataImpl): boolean {
    let enabled: boolean = true;

    if (
      item.lockType !== undefined &&
      item.lockType !== null &&
      (item.lockType === CubiqTS.LockType.FILL_LOCK ||
        item.lockType === CubiqTS.LockType.FILL_NOW_LOCK)
    ) {
      enabled = false;
    }

    return enabled;
  }

  public static get state(): any {
    return new BfxBlotterOrdersContextMenuItemTransferState();
  }
}
